import { render } from "./AddRoomate.vue?vue&type=template&id=06e12809&scoped=true"
import script from "./AddRoomate.vue?vue&type=script&lang=js"
export * from "./AddRoomate.vue?vue&type=script&lang=js"

import "./AddRoomate.vue?vue&type=style&index=0&id=06e12809&lang=css"
import "./AddRoomate.vue?vue&type=style&index=1&id=06e12809&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\SpliytGit\\SpliytAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e12809"]])

export default __exports__